// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".icon[data-v-f71ae94c]{display:inline-block!important;height:100%;vertical-align:text-bottom;width:2rem}.icon-fa[data-v-f71ae94c]{height:1em;vertical-align:middle;width:1em}.small .icon-fa[data-v-f71ae94c]{height:.8em;width:.8em}.big .icon-fa[data-v-f71ae94c]{height:1.2em;width:1.2em}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
